import { render, staticRenderFns } from "./EMWidgetBoard.vue?vue&type=template&id=697c0bea&scoped=true&"
import script from "./EMWidgetBoard.vue?vue&type=script&lang=js&"
export * from "./EMWidgetBoard.vue?vue&type=script&lang=js&"
import style0 from "./EMWidgetBoard.vue?vue&type=style&index=0&id=697c0bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697c0bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardTitle,VCol,VIcon,VProgressCircular,VSpacer})
